import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Box, Link } from 'roo-ui/components';
import { scrollTop } from 'lib/browser';
import noop from 'lodash/noop';

const PreviousLink = ({ page, currentQuery, pathname, onClick }) => {
  const newQuery = { ...currentQuery, page: page - 1 };
  const linkTo = { pathname, search: queryString.stringify(newQuery) };

  const handleOnClick = () => {
    onClick(newQuery.page);
    scrollTop();
  };

  return (
    <Box>
      {page > 1 && (
        <Link underline as={RouterLink} to={linkTo} color="greys.charcoal" data-testid="prev-link" px={3} py={1} onClick={handleOnClick}>
          Previous
        </Link>
      )}
    </Box>
  );
};

PreviousLink.propTypes = {
  page: PropTypes.number.isRequired,
  currentQuery: PropTypes.shape({}).isRequired,
  pathname: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

PreviousLink.defaultProps = {
  onClick: noop,
};

export default PreviousLink;
